// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__XNA9c","errorPageLogo":"ErrorPage_errorPageLogo__ClbZR"};